import React, { Component, Fragment } from "react";

import Level from "./levels";

export default class GeneroContainer extends Component {
  getPng = (png) => {
    switch (png.toLowerCase()) {
      case "masculino":
        return "g-masculino.png";
      case "femenino":
        return "g-femenino.png";
      default:
        break;
    }
  };

  getOtherPng = (png) => {
    switch (png.toLowerCase()) {
      case "femenino":
        return "g-masculino.png";
      case "masculino":
        return "g-femenino.png";
      default:
        break;
    }
  };

  getPercent = (val) => {
    const total = this.props.data.dataSet.reduce((a, b) => ({
      value: a.value + b.value,
    })).value;
    return (val * 100) / total;
  };

  getLevel = () => {
    const { top, button, data } = this.props;
    if (data === undefined || data.dataSet.length === 0) {
      return (
        <Fragment>
          <div>
            <Level
              width={this.props.width}
              height={this.props.height}
              level={0}
              image="g-masculino.png"
              colorTop={top}
              colorBottom={button}
              name={this.props.name + "-uno"}
            />
            0
            <Level
              width={this.props.width}
              height={this.props.height}
              level={0}
              image="g-femenino.png"
              colorTop={top}
              colorBottom={button}
              name={this.props.name + "-dos"}
            />
            0
          </div>
        </Fragment>
      );
    } else if (data.dataSet.length === 1) {
      return (
        <Fragment>
          <div>
            <Level
              width={this.props.width}
              height={this.props.height}
              level={100}
              image={this.getPng(data.dataSet[0].name)}
              colorTop={top}
              colorBottom={button}
              name={this.props.name + "-uno"}
            />
            {data.dataSet[0].value}
            <Level
              width={this.props.width}
              height={this.props.height}
              level={0}
              image={this.getOtherPng(data.dataSet[0].name)}
              colorTop={top}
              colorBottom={button}
              name={this.props.name + "-dos"}
            />
            0
          </div>
        </Fragment>
      );
    } else {
      return (
        <div>
          {data.dataSet
            .filter((dato) => {
              if (dato.id === "LGBTIQ") return false;
              return true;
            })
            .map((dato, index) => {
              return (
                <Fragment key={"genero-key-" + index}>
                  <Level
                    key={"genero-" + this.props.name + "-" + index}
                    width={this.props.width}
                    height={this.props.height}
                    level={this.getPercent(dato.value)}
                    image={this.getPng(dato.name)}
                    colorTop={top}
                    colorBottom={button}
                    name={this.props.name + "-uno-" + index}
                  />
                  {dato.value}
                </Fragment>
              );
            })}
        </div>
      );
    }
  };
  getHeader = () => {
    try {
      return this.props.data.title.split(" - ")[1];
    } catch (e) {
      return "";
    }
  };
  render() {
    return (
      <Fragment>
        <div>{this.getHeader()}</div>
        {this.getLevel()}
      </Fragment>
    );
  }
}
